// extracted by mini-css-extract-plugin
export default {"lz_menu":"Menu_lz_menu__DA-kj","lz_main-menu":"Menu_lz_main-menu__rPpge","lz_menu-logo":"Menu_lz_menu-logo__O9hdu"};